import Helpers from '@/shared/helpers/functions';

import { PolicyParticipation } from '@/resources/models/policy-participations';
import { EmploymentRelationship } from '@/resources/models/employment-relationships';

const EMPLOYEE_EXPIRATION_IN_DAYS = 30;

class Employee {
  constructor (data = {}) {
    this.id = data.id;

    this.externalId = data.externalId;
    this.customerNumber = data.customerNumber;
    this.initials = data.initials;
    this.middleName = data.middleName;
    this.lastName = data.lastName;
    this.middleNamePartner = data.middleNamePartner;
    this.lastNamePartner = data.lastNamePartner;
    this.middleName = data.middleName;
    this.gender = data.gender;

    this.registrationDate = data.registrationIsoDate;
    this.terminationDate = data.terminationIsoDate;
    this.dateOfBirth = data.isoDateOfBirth;
    this.dateOfDeath = data.isoDateOfDeath;

    this.bsn = data.bsnNumber;
    this.email = data.email;
    this.street = data.street;
    this.houseNumber = data.houseNumber;
    this.houseNumberExtension = data.houseNumberExtension;
    this.mailbox = data.mailbox;
    this.zipCode = data.zipCode;
    this.city = data.city;
    this.country = data.country;

    this.name = this.getFullName();

    this.isActive = this._getIsActive(); // data.isActive;

    if (data.policyParticipations) {
      this.allParticipations = data.policyParticipations
        .map(p => new PolicyParticipation(p));

      this.participations = this.allParticipations.filter(p => p.isActive);
    }

    if (data.employmentRelationShips) {
      this.employmentRelationships = data.employmentRelationShips
        .map(e => {
          return new EmploymentRelationship(e);
        })
        .sort((a, b) => new Date(a.fromDate) > new Date(b.fromDate) ? -1 : 1);
    } else this.employmentRelationships = [];

    /*     let double = [];
    this.employmentRelationships.forEach(e => {
      double.push(e);
      double.push(e);
      double.push(e);
    });
    this.employmentRelationships = double; */

    this.employeeNumber = null;
    if (this.employmentRelationships.length > 0) {
      this.employeeNumber = this.employmentRelationships[0].employeeNumber;
    }
  }

  getSearchString () {
    return String(this.id) +
      String(this.initials) +
      String(this.middleName) +
      String(this.lastName) +
      String(this.middleNamePartner) +
      String(this.lastNamePartner) +
      String(this.middleName) +
      String(this.dateOfBirth) +
      Helpers.Dates.formatDate(this.dateOfBirth) +
      Helpers.Dates.searchDates(this.dateOfBirth) +
      String(this.customerNumber) +
      String(this.employeeNumber) +
      String(this.bsn) +
      String(this.email);
  }

  _getIsActive () {
    if (this.terminationDate == null || this.terminationDate === '') return true;
    if (Helpers.Dates.differenceFromNowInDays(this.terminationDate) < EMPLOYEE_EXPIRATION_IN_DAYS) return true;
    return false;
  }

  getName () {
    let result = '';
    if (this.initials) result += this.initials;
    if (this.middleName) result += ` ${this.middleName}`;
    if (this.lastName) result += ` ${this.lastName}`;
    return result;
  }

  getNamePartner () {
    let result = '';
    if (this.middleNamePartner) result += ` ${this.middleNamePartner}`;
    if (this.lastNamePartner) result += ` ${this.lastNamePartner}`;
    return result;
  }

  getFullName () {
    let result = '';

    if (this.initials) result += this.initials;
    if (this.middleName) result += ` ${this.middleName}`;
    if (this.lastName) result += ` ${this.lastName}`;

    if (this.lastNamePartner) {
      result += ' -';
      if (this.middleNamePartner) result += ` ${this.middleNamePartner}`;
      result += ` ${this.lastNamePartner}`;
    }
    return result;
  }

  getBody () {
    return {
      id: this.id,
      initials: this.initials,
      lastName: this.lastName,
      lastNamePartner: this.lastNamePartner,
      middleName: this.middleName,
      gender: this.gender,
      isoDateOfBirth: this.dateOfBirth,
      isoDateOfDeath: this.dateOfDeath,
      externalId: this.externalId,
      registrationDate: this.registrationDate,
      terminationDate: this.terminationDate,
      bsn: this.bsn,
      email: this.email,
      street: this.street,
      houseNumber: this.houseNumber,
      zipCode: this.zipCode,
      city: this.city
    };
  }
}

export {
  Employee as
  default
};
